import { Details } from './Details';
export class SectorModel {
    nameEn: string;
    nameFr: string;
    details: Details[] = [];
}
